// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1Z6FI","icon":"SortAdornment_icon__37i5-","up":"SortAdornment_up__3YKAN","down":"SortAdornment_down__2P4Du","active":"SortAdornment_active__3W3RV"};